import WorkDocument from "work/work-agreements/contracts/work-document";

export type ReplaceableDocumentAPIRequestPayload = {
    documentId?: string;
    replacesId?: string;
};

export default class ReplaceableDocumentAPIRequest {
    documentId?: string;
    replacesId?: string;

    constructor(document?: WorkDocument) {
        this.documentId = document?.id.value;
        this.replacesId = document?.replacesId?.value;
    }

    public get payload(): ReplaceableDocumentAPIRequestPayload {
        return {
            documentId: this.documentId,
            replacesId: this.replacesId
        };
    }
}
